import React from 'react';
import { useHistory } from 'react-router-dom';
// Elements
import { DrawerHeader, DrawerContent, DrawerLink } from 'elements/Drawer';
// Utils
import { validArray, isEmptyObject, setSessionStorageItem, removeSessionStorageItem } from 'utils';
import { useAuthDispatch, useAuthState } from 'context/AuthContext';
import { setDefaultOrganisation } from 'context/AuthContext/actions';

function ChangeOrganisation({ organisations }: { organisations: [] }) {
  // Router
  const history = useHistory();
  // Auth Context
  const authDispatch = useAuthDispatch();
  const { defaultOrganisation } = useAuthState();
  const { orgDescription } = defaultOrganisation || [];

  // Render Organisation
  function renderOrganisation(organisation:{ orgDescription: string, orgRef: string }) {
    function findOrganisation(target:{ orgDescription: string }) {
      return organisation.orgDescription === target.orgDescription;
    }
    
    function handleOrganisationClick() {
      const targetOrganisation = validArray(organisations) && organisations.find(findOrganisation);
      if (!isEmptyObject(targetOrganisation)) {
        authDispatch(setDefaultOrganisation(targetOrganisation));
        setSessionStorageItem({ key: 'defaultOrganisation', item: targetOrganisation });
        removeSessionStorageItem({ item: 'defaultPrinter' });
        history.push('/');
      }
    }

    return (
      <li key={organisation.orgDescription}>
        <DrawerLink
          active={organisation.orgDescription === orgDescription}
          handler={handleOrganisationClick}
          icon="Organisations"
          iconBackground={organisation.orgDescription === orgDescription ? 'tertiary' : 'tertiary-200'}
          label={organisation.orgDescription}
        />
      </li>
    );
  }

  return (
    <>
      <DrawerHeader>
        <h4 className="display6">Select Organisation</h4>
      </DrawerHeader>
      <DrawerContent>
        <h5>Available Organisations</h5>
        <ul>
          {organisations && organisations.map(renderOrganisation)}
        </ul>
      </DrawerContent>
    </>
  );
}

export default ChangeOrganisation;